module.exports = __webpack_public_path__ + "static/media/2-option1-4row.64743892.png";